<!-- User rounded button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" (menuOpened)="loadTwoFactorStatus()">
  @if (user.photoProfileId?.value) {
    <img
      class="rounded-full w-7 h-7"
      alt="avatar image"
      [src]="avatarImgUrl"
      />
  }

  @if (!user.photoProfileId?.value) {
    <div
      class="w-7 h-7 rounded-full text-[10px] bg-primary flex justify-center items-center"
      >
      {{ avatarFirstName.charAt(0) + avatarLastName.charAt(0) }}
    </div>
  }
</button>

<!-- Button menu -->
<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <!-- Representante legal -->
  @if (user?.userType === 'entity') {
    <button mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>Representante legal</span>
        <span class="mt-1.5 text-md font-medium">
          {{ user?.manager?.firstname }} {{ user?.manager?.surname }}
        </span>
      </span>
    </button>
  }

  @if (user?.userType === 'entity') {
    <mat-divider class="my-2"></mat-divider>
  }

  <!-- Invertir como sociedad -->
  <button mat-menu-item [routerLink]="['/entity/activate']">
    <mat-icon [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
    <span>Invertir como sociedad</span>
  </button>

  <!-- Mi perfil - Active -->
  @if (canGotoMiPerfil) {
    <button mat-menu-item [routerLink]="['/profile']">
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      <span>Mi perfil</span>
    </button>
  }

  <!-- Mi perfil - Disabled -->
  @if (!canGotoMiPerfil) {
    <div
      matTooltip="Podrás acceder a tu perfil una vez que hayas completado el Paso 3"
      matTooltipPosition="right"
      #miPerfilTooltip="matTooltip"
      (click)="miPerfilTooltip.toggle()"
      >
      <button mat-menu-item disabled>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Mi perfil</span>
      </button>
    </div>
  }

  <!-- Preguntas frecuentes -->
  <button mat-menu-item>
    <a
      href="https://intercom.help/betterplan-advisors/es"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center"
      >
      <mat-icon [svgIcon]="'mat_outline:help_outline'"></mat-icon>
      <span>Preguntas frecuentes</span>
    </a>
  </button>

  <!-- Mostrar valores del debug -->
  @if (isDebugMode) {
    <button mat-menu-item (click)="showDebugPage()">
      <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
      <span>Mostrar valores del debug</span>
    </button>
  }

  <!-- Cambiar de usuario -->
  @if (isAdminUser || canChangeUser) {
    <button mat-menu-item [routerLink]="['/companies']">
      <mat-icon [svgIcon]="'mat_solid:people_outline'"></mat-icon>
      <span>Cambiar de usuario</span>
    </button>
  }

  <!-- Cambiar imagen de usuario -->
  <button mat-menu-item (click)="avatarInput.click()">
    <mat-icon [svgIcon]="'mat_solid:add_a_photo'"></mat-icon>
    <span>Cambiar imagen de usuario</span>
  </button>

  <!-- Seguridad (feature 056, T034, maqueta B13.b): estado del doble factor propio y acceso a la
       página «Seguridad» de Identity en una pestaña nueva. El ícono externo va DENTRO del span:
       mat-menu-item proyecta en la ranura de ícono inicial todo mat-icon que sea hijo directo. -->
  <button
    mat-menu-item
    type="button"
    data-testid="bp-user-security"
    [disabled]="!securityBaseUrl()"
    (click)="onOpenSecurity()"
    >
    @if (twoFactorStatus()?.enabled) {
      <mat-icon
        svgIcon="heroicons_outline:shield-check"
        class="!text-green-700"
        data-testid="bp-user-security-icon-on"
      ></mat-icon>
    } @else {
      <mat-icon svgIcon="mat_outline:shield" data-testid="bp-user-security-icon-off"></mat-icon>
    }
    <span class="flex items-center gap-3 w-full">
      <span class="flex flex-col flex-1 min-w-0 leading-tight py-1">
        <span>Seguridad</span>
        @if (twoFactorLoading() || twoFactorSubtitle()) {
          <span>
            <span
              class="block text-sm text-secondary mt-0.5"
              data-testid="bp-user-security-subtitle"
              [bp-skeleton]="twoFactorLoading()"
              skeletonWidth="32"
              skeletonHeight="3"
              >{{ twoFactorSubtitle() }}</span
            >
          </span>
        }
      </span>
      <mat-icon
        svgIcon="heroicons_outline:arrow-top-right-on-square"
        class="icon-size-4 !mr-0"
        aria-hidden="true"
      ></mat-icon>
    </span>
  </button>

  <mat-divider class="my-2"></mat-divider>

  <!-- Cerrar sesión -->
  <button mat-menu-item (click)="onLogout()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>

<!-- Img file input -->
<input
  #avatarInput
  hidden
  class=""
  type="file"
  title=" "
  accept="image/*"
  (change)="onAddFile($event)"
  />
